export default "__VITE_ASSET__ae8c7237__"